module.exports = __webpack_public_path__ + "img/Speaker=Peter Poydenko.91c42e94.png";